import { connect } from 'react-redux';
import Component from './Component';
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';

export default connect(mapStateToProps, mapDispatchToProps)(Component);
